// extracted by mini-css-extract-plugin
export var copyIcon = "_r0-2";
export var discountCard = "_r0-0";
export var discountCode = "_r0-3";
export var discountContent = "_r0-1";
export var loadingCard = "_r0-4";